export default __webpack_public_path__ + "e29c28dbae537739dc36f98aee0fc7cf.svg";